<template>
    <div>

        <el-table :data="pageList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading"
                  v-show="!showDialog">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="id" label="ID" width="100">
            </el-table-column>
            <el-table-column prop="prizeName" label="奖品名称" width="150">
            </el-table-column>
            <el-table-column prop="prizeDesc" label="奖品描述"></el-table-column>
            <el-table-column prop="prizeCount" label="奖项数量" width="90"></el-table-column>
            <el-table-column prop="level" label="奖项等级" width="90"></el-table-column>
            <el-table-column prop="prizeType" label="prizeType" >
                <template slot-scope="scope">
                    <span>{{scope.row.prizeType == 1 ? '优惠券' : '手工发放'}}</span>
                </template>
            </el-table-column>

            <el-table-column prop="createTime" label="创建时间" width="120">
            </el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot="header" slot-scope="scope">
                    操作
                    <el-button type="primary" size="mini" v-show="showNew" @click="addData()">新建</el-button>
                </template>
                <template slot-scope="scope">
                    <el-button type="success" size="mini" @click="editData(scope.row)">编辑</el-button>
                    <el-button type="warning" size="mini" @click="deleteData(scope.row)">删除</el-button>

                </template>

            </el-table-column>
        </el-table>


        <el-dialog title="编辑" :visible.sync="showDialog">
            <el-form :model="dataEntity" :rules="rules"  ref="dataEntity" label-width="130px" class="demo-ruleForm">

                <el-form-item prop="prizeName" label="奖项名称">
                    <el-input v-model="dataEntity.prizeName" placeholder="奖项名称"></el-input>
                </el-form-item>

                <el-form-item label="奖项级别" prop="level" >
                    <el-input-number v-model="dataEntity.level" :min="1" :max="5"
                                     placeholder="奖项级别" ></el-input-number>
                </el-form-item>
                <el-form-item prop="prizeCount" label="奖项数量" >
                    <el-input-number v-model="dataEntity.prizeCount" :min="0" :max="100000"
                                     placeholder="奖项数量" ></el-input-number>
                </el-form-item>
                <el-form-item label="奖项类型" prop="prizeType">
                    <el-select v-model="dataEntity.prizeType"  placeholder="奖项类型" >
                        <el-option
                                v-for="item in prizeTypeList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="奖项优惠券选择" prop="prizeData"  >
                    <el-select v-model="dataEntity.prizeData" filterable clearable  placeholder="优惠券选择" >
                        <el-option
                                v-for="item in activeList"
                                :key="item.bindCode"
                                :label="item.activeName"
                                :value="item.bindCode">
                        </el-option>
                    </el-select>
                </el-form-item>

<!--                <el-form-item label="奖项条件" prop="prizeConditionId">-->
<!--                    <el-select v-model="dataEntity.prizeConditionId" clearable placeholder="奖项条件" >-->
<!--                        <el-option-->
<!--                                v-for="item in prizeConditionList"-->
<!--                                :key="item.id"-->
<!--                                :label="item.name"-->
<!--                                :value="item.id">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
                <el-form-item label="指定获奖用户" prop="prizeUser">
                    <el-input v-model="dataEntity.prizeUser" placeholder="指定获奖" disabled="disabled"></el-input>请在预约用户列表指定
                </el-form-item>
                <el-form-item prop="prizeDesc" label="奖项描述">
                    <el-input v-model="dataEntity.prizeDesc" placeholder="奖项描述"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveEntity()" class="header-btn">
                    保 存
                </el-button>
            </div>
        </el-dialog>
    </div>

</template>
<script>
    //导入 HTTP请求方法
    import {
        getActiveForOptionListByType,
        luckydraw_prizeList,
        luckydraw_getPrize,
        luckydraw_addPrize,
        luckydraw_deletePrize,
        luckydraw_get, luckydraw_delete,getConditionOptions
    } from '../../api/api';
    export default {
        data() {
            return {

                showDialog: false,
                loading: true,
                showNew:false,
                pageList:[],
                activeList:[],
                prizeTypeList:[{id:1,name:'优惠券'},{id:2,name:'手工发放'}],
                prizeConditionList:[],
                canEdit:true,

                dataEntity: {
                    id:'',
                    luckyDrawId:this.$route.query.id,
                    bindCode:this.$route.query.bindCode,
                    prizeName:'',
                    prizeDesc:'',
                    prizeCount:1,
                    prizeConditionId:'',
                    prizeType:1,
                    przieData:'',
                    level:'',
                    prizeUser:''

                },
                rules: {
                    prizeName: [
                        {required: true, message: '请输入奖项名称', trigger: 'blur'},
                        {min: 2, max: 40, message: '长度在 2 到 40 个字符之间', trigger: 'blur'}
                    ],
                    prizeDesc: [
                        {min: 0, max: 200, message: '长度在 0 到 200 个字符之间', trigger: 'blur'}
                    ],
                    prizeType: [
                        {required: true, message: '请选择奖项类型', trigger: 'blur'},
                    ],
                },
                formInline:{
                    bindCode:this.$route.query.bindCode,
                    luckyDrawId:this.$route.query.id,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                }
            }
        },
        //挂载时候执行
        mounted(){
            //领券活动
            getActiveForOptionListByType({activeType:15}).then((res) => {
                this.activeList = res.data.value;
            })
            getConditionOptions().then((res) => {
                this.prizeConditionList = res.data.value;
            })
            this.showNew=typeof(this.formInline.luckyDrawId) == "undefined"?false:true;
            console.log(this.showNew);
            //初始化首页数据
            this.getlist();


        },
        methods: {
            getlist(){
                this.loading = true;
                luckydraw_prizeList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        //this.formInline.recordsTotal = res.data.value.total;
                        this.pageList= res.data.value;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },

            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getlist();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getlist();
            },
            addData(){
                this.showDialog=true;
                this.dataEntity.id='';
                this.dataEntity.prizeName='';
                this.dataEntity.prizeDesc='';
                this.dataEntity.prizeUser='';
                this.dataEntity.prizeCount=1;
                this.dataEntity.prizeType=1;
                this.dataEntity.level='';

                this.canEdit=true;
            },
            editData(row){
                this.luckydraw_getPrize(row);
                this.showDialog=true;
            },
            deleteData(row){
                this.$confirm('删除奖项, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading(this.GCONFIG.loadingParam);
                    luckydraw_deletePrize({id:row.id}).then((res) => {
                        loading.close();
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getlist();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },
            saveEntity(){
                this.loading = true;
                this.$refs.dataEntity.validate((valid) => {
                    if (valid) {
                        //保存
                        luckydraw_addPrize(this.dataEntity).then((res) => {
                            this.loading = false;
                            this.showDialog = false;
                            if (res.data.status == 200) {
                                this.$message({
                                    message: '保存成功',
                                    type: 'success'
                                });
                                this.getlist();
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: res.data.message,
                                    type: 'error'
                                });
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
            returnHistory(){
                window.history.back()
            },
            luckydraw_getPrize(row){
                this.canEdit=false;
                luckydraw_getPrize({"id":row.id}).then(res => {
                    this.dataEntity = res.data.value;
                });
            },

        }
    }
</script>


// WEBPACK FOOTER //
// src/views/lucky/prizeList.vue